// extracted by mini-css-extract-plugin
export var buttonContent = "_3v-0";
export var centered = "_3v-1";
export var centeredFlex = "_3v-2";
export var errorText = "_3v-3";
export var icon = "_3v-4";
export var iconButtonContent = "_3v-5";
export var monospace = "_3v-6";
export var padded = "_3v-7";